import React from 'react';
import styled from 'styled-components';

export const ErrorNotificationContent: React.FC<{
  headline: string;
}> = ({headline}) => {
  return <Wrapper>{headline}</Wrapper>;
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;
